import { useMemo } from "react";

export function usePermission(permissions = []) {
  const normalized = useMemo(
    () =>
      permissions
        ?.map((p) => p?.name?.toLowerCase()?.trim())
        ?.filter(Boolean) || [],
    [permissions]
  );

  const check = (perm) => normalized.includes(perm.toLowerCase().trim());
  const hasAny = (list = []) => list.some(check);
  const hasAll = (list = []) => list.every(check);

  return { check, hasAny, hasAll };
}